import { StateService, UIRouterGlobals } from "@uirouter/angular";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
  selector: "no-checkins",
  templateUrl: "./no-checkins.component.html",
  styleUrls: ["./no-checkins.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoCheckInsComponent {
  @Input()
  public includeCTAButton = true;

  @Input()
  public teamId: string;

  constructor(private stateService: StateService, private routerGlobals: UIRouterGlobals) {}

  public goToManageReflections(): void {
    const relativePath = this.routerGlobals.current.name.replace(".reflection", "");
    this.stateService.go(`${relativePath}.reflection`, { teamId: this.teamId });
  }
}
